import React, { useState, useMemo } from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";
import Project from "./Projects/Project";

const ProjectsList = props => {
  const {
    openProjects,
    closedProjects,
    closedMissionsCount,
    listClassname = "",
  } = props;
  const [currentPage, setCurrentPage] = useState(2);

  const mapComponent = (project, index, key) => (
    <Project {...project} key={`${key}-${index}`} />
  );

  const Separator = (
    <div className="pProjects_pagedTitle" key="separator">
      <h3>{closedMissionsCount} previous jobs</h3>
    </div>
  );

  const items = useMemo(
    () => [
      ...openProjects.map((project, idx) => mapComponent(project, idx, "open")),
      ...[Separator, null, null],
      ...closedProjects.map((project, idx) =>
        mapComponent(project, idx, "closed")
      ),
    ],
    [openProjects, closedProjects, Separator]
  );

  const [sentryRef] = useInfiniteScroll({
    hasNextPage: items.length / 3 > currentPage,
    loading: false,
    onLoadMore: () => {
      console.log("Load more projects");
      setCurrentPage(currentPage + 1);
    },
  });

  return (
    <div className="oPager">
      <div className={`oPager_items ${listClassname}`}>
        {items.slice(0, currentPage * 3)}
        <div ref={sentryRef} key="sentry" />
      </div>
    </div>
  );
};

export default ProjectsList;
